// ======================== SELECT ======================== //
const GET_USER_PUBLIC = `
query GetUser($uid: String) {
  v_user_public(where: {id: {_eq: $uid}}) {
    avatar
    cover
    email
    fullname
    id
    name_color
    type_user
    username
  }
}
`
const GET_LESSONS_HOME = `
query getLessons($keyword: String, $type_lesson: Int, $is_public: Int, $limit: Int, $user_id: String) {
  v_front_lesson(where: {_or: [{name: {_ilike: $keyword}}, {fullname: {_ilike: $keyword}}], type_lesson: {_eq: $type_lesson}, is_public: {_eq: $is_public}}, order_by: {updated_at: desc}, limit: $limit) {
    id
    name
    read
    type_lesson
    subject_name
    subject_id
    grade_name
    grade_id
    fullname
    count_share
    count_like
    count_comment
    banner
    avatar
    updated_at
    content
    files
    link_video
    thumbnail
  }
}
`
const GET_LESSONS_LIKE_USER_HOME = `
query getLesssonLikeUser($user_id: String) {
  likes_lesson(where: {user_id: {_eq: $user_id}}) {
    object_id
  }
}
`

const GET_LESSONS_LIKE_HOME = `
query getLesssonLike($object_id: Int, $user_id: String) {
  likes_lesson(where: {user_id: {_eq: $user_id}, object_id: {_eq: $object_id}}) {
    object_id
    user_id
  }
}
`

const GET_SUBJECTS = `
query getSubjects {
  subjects(where: {is_delete: {_eq: false}}, order_by: {name: asc}) {
    id
    name
  }
}
`
const GET_GRADES = `
query getGrades {
  grades(order_by: {updated_at: asc}, where: {is_delete: {_eq: false}}) {
    id
    name
  }
}
`
const GET_LESSONS_PAGE = `
query getLessonsPage($keyword: String, $type_lesson: Int, $is_public: Int, $limit: Int, $offset: Int, $user_id: String, $lstGrade: [Int!], $lstSubject: [Int!]) {
  v_front_lesson(where: {_or: [{name: {_ilike: $keyword}}, {fullname: {_ilike: $keyword}}], type_lesson: {_eq: $type_lesson}, is_public: {_eq: $is_public}, grade_id: {_in: $lstGrade}, subject_id: {_in: $lstSubject}}, order_by: {updated_at: desc}, limit: $limit, offset: $offset) {
    id
    name
    read
    type_lesson
    subject_name
    subject_id
    grade_name
    grade_id
    fullname
    count_share
    count_like
    count_comment
    banner
    avatar
    updated_at
    content
    files
    link_video
    thumbnail
    teacher_id
  }
}`

const GET_LESSONS_DETAIL = `
query getLessonsDetail($type_lesson: Int!, $is_public: Int, $id: Int!) {
  v_front_lesson(where: {type_lesson: {_eq: $type_lesson}, is_public: {_eq: $is_public}, id: {_eq: $id}}) {
    id
    name
    read
    type_lesson
    subject_name
    subject_id
    grade_name
    grade_id
    fullname
    count_share
    count_like
    count_comment
    banner
    avatar
    updated_at
    content
    files
    link_video
    thumbnail
  }
}`

const GET_PC_PAGE = `
query getPCPage($keyword: String, $limit: Int, $offset: Int, $lstSubject: [Int!], $orderBy: [v_front_pc_order_by!]) {
  v_front_pc(where: {_or: [{name: {_ilike: $keyword}}, {fullname: {_ilike: $keyword}}], subject_id: {_in: $lstSubject}}, limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    name
    icon
    banner
    site_id
    user_id
    fullname
    avatar
    subject_id
    subject_name
    count
    created_at
  }
}
`
const GET_USER_JOIN_PC = `
query userJoinPC($pc_id: Int, $user_id: String, $status: Int) {
  pc_user(where: {pc_id: {_eq: $pc_id}, user_id: {_eq: $user_id}}) {
    pc_id
    user_id
  }
  v_front_pc_join_user_aggregate(where: {user_id_request: {_eq: $user_id}, status: {_eq: $status}, pc_id: {_eq: $pc_id}}) {
    aggregate {
      count
    }
  }
}
`

const GET_PC_LANDING_PAGE = `
query getLandingPC($where: private_community_bool_exp, $whereTwo: classes_bool_exp) {
  private_community(where: $where) {
    id
    name
    icon
    banner
    site_id
    user_id
    subject_id
    description
    classes(where: $whereTwo, order_by: {created_at: asc}) {
      id
      name
      thumbnail
    }
    user_public {
      id
      fullname
      avatar
      type_user
      userquotes
    }
  }
}
`

const GET_LANDING_PC_LESSON = `
query getLessons($wherePC: private_community_bool_exp, $where: v_front_lesson_bool_exp, $order_by: [v_front_lesson_order_by!], $offset: Int, $limit: Int) {
  private_community(where: $wherePC) {
    pc_front_lesson(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      name
      read
      type_lesson
      subject_name
      subject_id
      grade_name
      grade_id
      fullname
      count_share
      count_like
      count_comment
      banner
      avatar
      updated_at
      content
      files
      link_video
      thumbnail
      teacher_id
    }
  }
}
`
const GET_PC_WHERE_ANY = `
query getPCWhereAny($where: private_community_bool_exp) {
  private_community(where: $where) {
    id
    name
    icon
    banner
    site_id
    user_id
    subject_id
    description
  }
}
`
const GET_JOIN_PC_USER_CLASSES = `
query getJoinPCUserClass($objWhere: pc_user_bool_exp, $limit: Int) {
  pc_user(where: $objWhere, limit: $limit) {
    pc_id
    classes_id
    status
    un_pin
    position
    un_pin_class
    is_delete
    classes {
      id
      name
      pc_id
      private
    }
  }
}
`
const GET_CLASSES = `
query getClasses($where: classes_bool_exp) {
  classes(where: $where) {
    id
    name
    grade_id
    pc_id
    thumbnail
    private
    type_approval
  }
}
`
const GET_EXERCISE = `
query getExercise($where: v_front_exercise_bool_exp, $offset: Int, $limit: Int, $order_by: [v_front_exercise_order_by!]){
  v_front_exercise(where:$where, offset: $offset, limit: $limit, order_by: $order_by) {
    id
    name
    name_en
    status
    type_test
    level
    time
    updated_at
    grade_name
    grade_id
    count_share
    count_like
    count_comment
    amount_honey
    is_public
  }
}
`
const GET_EXERCISE_USER = `
query getExerciseUser($where: v_front_exercise_user_bool_exp, $offset: Int, $limit: Int, $order_by: [v_front_exercise_user_order_by!]){
  v_front_exercise_user(where:$where, offset: $offset, limit: $limit, order_by: $order_by) {
    id
    name
    name_en
    status
    type_test
    level
    is_done_exercise
    time
    updated_at
    user_id
    grade_name
    grade_id
    fullname
    deadline
    count_share
    count_like
    count_comment
    avatar
    amount_honey
    is_public
    is_public_pc
    class_id
  }
}
`

const GET_QUESTION_TO_EXERCISE = `
query getQuestionExercise($where: question_exercise_bool_exp, $orderBy: [question_exercise_order_by!]) {
  question_exercise(where: $where, order_by: $orderBy) {
    question_id
    exercise_id
    exercise {
      id
      name
      name_en
      categ_id
      amount_honey
    }
    question {
      id
      content
      time
      level
      link_audio
      categ_id
      subject_id
      is_lock
      amount_honey
      question_details(where: {is_delete: {_eq: false}}, order_by: {id: asc}) {
        id
        content
        explain
        point
        sub_point
        is_shuffle
        type
        answers(where: {is_delete: {_eq: false}}, order_by: {id: asc}) {
          id
          content
          is_correct
        }
      }
    }
  }
}
`
const GET_LIKE_EXERCISE = `
query getLikeExercise($where: like_exercise_bool_exp!) {
  like_exercise(where: $where) {
    object_id
    user_id
  }
}
`

const GET_USER_JOIN_CLASSES_EXERCISE = `
query getUserJoinClassesExercise($where: classes_bool_exp, $whereStudents: pc_user_bool_exp) {
  classes(where: $where) {
    id
    name
    pc_id
    students(where: $whereStudents) {
      pc_id
      classes_id
      status
    }
  }
}
`

const GET_RESULT_QUESTION_USER_EXCERCISE = `
query getResultExcerciseUser($where: result_bool_exp, $orderBy: [result_order_by!]) {
  result(where: $where, order_by: $orderBy) {
    id
    name
    user_id
    status
    exercise_id
    current_question
    amount_rank
    amount_diamond
    total_time
    total_score
    description
    buy_explain
    class_id
    result_details(order_by: {id: asc}) {
      id
      name
      question_id
      result_id
      score
      time
      link_audio
      question_result_details(order_by: {id: asc}) {
        id
        name
        result_details_id
        question_details_id
        answer_id
        answer_json
        value
        content
        status
        point
        mark
        point_plus
        point_minus
        type
      }
    }
  }
}
`
const GET_ROWS_USER_EXCERCISE = `
query getRowsExcerciseUser($where: result_bool_exp, $orderBy: [result_order_by!]) {
  result(where: $where, order_by: $orderBy) {
    id
    name
    description
    user_id
    total_score
    total_time
    amount_diamond
    amount_rank
    exercise_id
    status
    current_question
    buy_explain
    class_id
  }
}
`
const GET_SUM_QUESTION_DETAIL = `
query getSumQuestionDetail($where: question_result_details_bool_exp!) {
  question_result_details_aggregate(where: $where) {
    aggregate {
      sum {
        point
      }
    }
    nodes {
      result_details_id
      answer_id
    }
  }
}
`
const GET_SUM_RESULT_DETAIL = `
query getSumResultDetail($where: result_details_bool_exp!) {
  result_details_aggregate(where: $where) {
    aggregate {
      sum {
        score
      }
    }
    nodes {
      result_id
    }
  }
}
`
const GET_LESSON_OF_QUESTION = `
query getLessonOfQuestion($where: lesson_question_bool_exp, $orderBy: [v_front_lesson_order_by!]) {
  lesson_question(where: $where) {
    v_front_lesson(order_by: $orderBy) {
      id
      name
      read
      type_lesson
      subject_name
      subject_id
      grade_name
      grade_id
      fullname
      count_share
      count_like
      count_comment
      banner
      avatar
      updated_at
      content
      files
      link_video
      thumbnail
    }
    questionDetail {
      id
      explain
    }
  }
}
`
const GET_USER_INFO = `
query getUsers($where: users_bool_exp) {
  users(where: $where) {
    amount_honey
    amount_diamond
    amount_beepoint
    type_user
  }
}
`
const GET_GRADES_WHERE = `
query getGradesLesson($where: grades_bool_exp, $orderBy: [grades_order_by!]) {
  grades(where: $where, order_by: $orderBy) {
    id
    name
  }
}
`
const GET_SUBJECTS_WHERE = `
query getSubjectsWhere($where: subjects_bool_exp, $orderBy: [subjects_order_by!]) {
  subjects(where: $where, order_by: $orderBy) {
    id
    name
  }
}
`
const GET_LESSONS_PAGE2 = `
query getLessonsPage($where: v_front_lesson_bool_exp, $orderBy: [v_front_lesson_order_by!], $limit: Int, $offset: Int) {
  v_front_lesson(where: $where, order_by: $orderBy, limit: $limit, offset: $offset) {
    id
    name
    read
    type_lesson
    subject_name
    subject_id
    grade_name
    grade_id
    fullname
    count_share
    count_like
    count_comment
    banner
    avatar
    updated_at
    content
    files
    link_video
    thumbnail
    teacher_id
  }
}
`
const GET_PC_PAGE2 = `
query getPCPage($where: v_front_pc_bool_exp, $limit: Int, $offset: Int, $orderBy: [v_front_pc_order_by!]) {
  v_front_pc(where:$where, limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    name
    icon
    banner
    site_id
    user_id
    fullname
    avatar
    subject_id
    subject_name
    count
    created_at
  }
}
`

// ======================== UPDATE ======================== //
const UPDATE_LESSON_READ = `
mutation update_lesson_read($id: Int!, $read: Int!) {
  update_lesson(where: {id: {_eq: $id}}, _set: {read: $read}) {
    affected_rows
  }
}
`

const UPDATE_RESULT_EXERCISE_USER = `
mutation update_result($objWhere: result_bool_exp!, $objInput: result_set_input) {
  update_result(where: $objWhere, _set: $objInput) {
    affected_rows
    returning {
      id
      exercise_id
      class_id
    }
  }
}
`
const UPDATE_QUESTION_RESULT_DETAIL = `
mutation update_question_result_details($objWhere: question_result_details_bool_exp!, $objInput: question_result_details_set_input) {
  update_question_result_details(where: $objWhere, _set: $objInput) {
    affected_rows
    returning {
      point
      result_details_id
      question_details_id
      content
      answer_id
    }
  }
}
`
const UPDATE_RESULT_DETAIL = `
mutation update_result_details($objWhere: result_details_bool_exp!, $objInput: result_details_set_input) {
  update_result_details(where: $objWhere, _set: $objInput) {
    affected_rows
    returning {
      result_id
      score
    }
  }
}`

const UPDATE_USER_INFO = `
mutation updateUsers($objWhere: users_bool_exp!, $objInput: users_set_input) {
  update_users(_set: $objInput, where: $objWhere) {
    affected_rows
  }
}
`
const UPDATE_PC_USER = `
mutation update_user_join_PC($objWhere: pc_user_bool_exp!, $objInput: pc_user_set_input) {
  update_pc_user(where: $objWhere, _set: $objInput) {
    affected_rows
  }
}
`

// ======================== INSERT ======================== //
const LIKE_LESSONS_HOME = `
mutation create_lesson_like($user_id: String!, $object_id: Int!, $description: String) {
  insert_likes_lesson(objects: {user_id: $user_id, object_id: $object_id, description: $description}) {
    affected_rows
  }
}
`

const SEND_REQUEST_USER_JOIN_PC = `
mutation create_user_join_PC($objects: [pc_user_insert_input!]!) {
  insert_pc_user(objects: $objects) {
    affected_rows
  }
}
`
const CREATE_PC_HISTORY = `
mutation create_pc_history($objInput: [pc_history_insert_input!]!) {
  insert_pc_history(objects: $objInput) {
    affected_rows
  }
}`

const CREATE_USER_JOIN_TO_PC = `
mutation create_pc_user($objInput: [pc_user_insert_input!]!) {
  insert_pc_user(objects: $objInput) {
    affected_rows
  }
}
`
const LIKE_EXERCISE = `
mutation create_like_exercise($objectInput: [like_exercise_insert_input!]!) {
  insert_like_exercise(objects: $objectInput) {
    affected_rows
  }
}
`
const CREATE_RESULT_EXERCISE = `
mutation create_result_exercise($objectInput: [result_insert_input!]!) {
  insert_result(objects: $objectInput) {
    affected_rows
    returning {
      id
      exercise_id
      user_id
      status
    }
  }
}
`
const CREATE_RESULT_DETAIL_EXERCISE = `
mutation create_insert_result_details($objectInput: [result_details_insert_input!]!) {
  insert_result_details(objects: $objectInput) {
    affected_rows
    returning {
      id
      question_id
      result_id
    }
  }
}
`

const CREATE_QUESTION_DETAIL_EXERCISE = `
mutation create_question_result_details($objectInput: [question_result_details_insert_input!]!) {
  insert_question_result_details(objects: $objectInput) {
    affected_rows
    returning {
      id
      answer_id
      result_details_id
      question_details_id
    }
  }
}
`
const CREATE_HISTORY_POINT = `
mutation createHistoryPoint($objectInput: [history_point_insert_input!]!) {
  insert_history_point(objects: $objectInput) {
    affected_rows
  }
}
`

// ======================== DELETE ======================== //
const UNLIKE_LESSONS_HOME = `
mutation delete_lesson_like($user_id: String!, $object_id: Int!) {
  delete_likes_lesson(where: {user_id: {_eq: $user_id}, object_id: {_eq: $object_id}}){
    affected_rows
  }
}
`
const UNLIKE_EXERCISE = `
mutation delete_like_exercise($objectWhere: like_exercise_bool_exp!) {
  delete_like_exercise(where: $objectWhere) {
    affected_rows
  }
}
`
export default {
  // * ================ SELECT ================ *
  GET_USER_PUBLIC: GET_USER_PUBLIC,
  GET_LESSONS_HOME: GET_LESSONS_HOME,
  GET_LESSONS_LIKE_HOME: GET_LESSONS_LIKE_HOME,
  GET_LESSONS_LIKE_USER_HOME: GET_LESSONS_LIKE_USER_HOME,
  GET_SUBJECTS: GET_SUBJECTS,
  GET_GRADES: GET_GRADES,
  GET_LESSONS_PAGE: GET_LESSONS_PAGE,
  GET_LESSONS_DETAIL: GET_LESSONS_DETAIL,
  GET_PC_PAGE: GET_PC_PAGE,
  GET_USER_JOIN_PC: GET_USER_JOIN_PC,
  GET_PC_LANDING_PAGE: GET_PC_LANDING_PAGE,
  GET_PC_WHERE_ANY: GET_PC_WHERE_ANY,
  GET_JOIN_PC_USER_CLASSES: GET_JOIN_PC_USER_CLASSES,
  GET_LANDING_PC_LESSON: GET_LANDING_PC_LESSON,
  GET_CLASSES: GET_CLASSES,
  GET_QUESTION_TO_EXERCISE: GET_QUESTION_TO_EXERCISE,
  GET_EXERCISE: GET_EXERCISE,
  GET_EXERCISE_USER: GET_EXERCISE_USER,
  GET_LIKE_EXERCISE: GET_LIKE_EXERCISE,
  GET_USER_JOIN_CLASSES_EXERCISE: GET_USER_JOIN_CLASSES_EXERCISE,
  GET_RESULT_QUESTION_USER_EXCERCISE: GET_RESULT_QUESTION_USER_EXCERCISE,
  GET_ROWS_USER_EXCERCISE: GET_ROWS_USER_EXCERCISE,
  GET_SUM_QUESTION_DETAIL: GET_SUM_QUESTION_DETAIL,
  GET_SUM_RESULT_DETAIL: GET_SUM_RESULT_DETAIL,
  GET_LESSON_OF_QUESTION: GET_LESSON_OF_QUESTION,
  GET_USER_INFO: GET_USER_INFO,
  GET_GRADES_WHERE: GET_GRADES_WHERE,
  GET_SUBJECTS_WHERE: GET_SUBJECTS_WHERE,
  GET_LESSONS_PAGE2: GET_LESSONS_PAGE2,
  GET_PC_PAGE2: GET_PC_PAGE2,
  // * ================ UPDATE ================ *
  UPDATE_LESSON_READ: UPDATE_LESSON_READ,
  UPDATE_RESULT_EXERCISE_USER: UPDATE_RESULT_EXERCISE_USER,
  UPDATE_QUESTION_RESULT_DETAIL: UPDATE_QUESTION_RESULT_DETAIL,
  UPDATE_RESULT_DETAIL: UPDATE_RESULT_DETAIL,
  UPDATE_USER_INFO: UPDATE_USER_INFO,
  UPDATE_PC_USER: UPDATE_PC_USER,
  // * ================ INSERT ================ *
  LIKE_LESSONS_HOME: LIKE_LESSONS_HOME,
  SEND_REQUEST_USER_JOIN_PC: SEND_REQUEST_USER_JOIN_PC,
  CREATE_PC_HISTORY: CREATE_PC_HISTORY,
  CREATE_USER_JOIN_TO_PC: CREATE_USER_JOIN_TO_PC,
  LIKE_EXERCISE: LIKE_EXERCISE,
  CREATE_RESULT_EXERCISE: CREATE_RESULT_EXERCISE,
  CREATE_RESULT_DETAIL_EXERCISE: CREATE_RESULT_DETAIL_EXERCISE,
  CREATE_QUESTION_DETAIL_EXERCISE: CREATE_QUESTION_DETAIL_EXERCISE,
  CREATE_HISTORY_POINT: CREATE_HISTORY_POINT,
   // * ================ DELETE ================ *
  UNLIKE_LESSONS_HOME: UNLIKE_LESSONS_HOME,
  UNLIKE_EXERCISE: UNLIKE_EXERCISE
}



// WEBPACK FOOTER //
// ./src/components/Model/graphqlfront.js